(function() {
  function initPiFade() {
    // Текст и кнопки (но НЕ внутри карточек)
    var textSelectors = 'main h1, main h2, main h3, [class*="__heading"], [class*="__subheading"], [class*="__title"], [class*="__text"], [class*="__cta"], main p, main .button';
    document.querySelectorAll(textSelectors).forEach(function(el) {
      if (el.closest('header, footer, .drawer, .modal, .cart-drawer')) return;
      if (el.closest('.card-wrapper, .card, .services-wix__card, [class*="__cta"], .button, a.button, button')) return;
      if (el.classList.contains('pi-fade')) return;
      el.classList.add('pi-fade');
    });

    // Карточки товаров
    document.querySelectorAll('.card-wrapper').forEach(function(el) {
      if (el.closest('header, footer')) return;
      // Защита от вложенных
      if (el.parentElement && el.parentElement.closest('.card-wrapper')) return;
    });

    // Observer для текста
    var textObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('pi-fade--in');
          textObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    document.querySelectorAll('.pi-fade:not(.pi-fade--in)').forEach(function(el) {
      textObserver.observe(el);
    });

    // Observer для карточек
    var cardObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('pi-card--in');
          cardObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });
    document.querySelectorAll('.card-wrapper:not(.pi-card--in), .services-wix__card:not(.pi-card--in)').forEach(function(el) {
      cardObserver.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPiFade);
  } else {
    initPiFade();
  }
  window.addEventListener('load', initPiFade);
  setTimeout(initPiFade, 500);
})();